import * as React from 'react';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import { ThemeProvider } from '@mui/material/styles';
import NotificationsHost from './shared/feedback/NotificationsHost';
import { canEditTranslations } from './features/translationEditor/state/canEditTranslations';
import { theme } from './shared/theme';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { loadSystemInfoSuccess } from './actions/sysInfoActions';
import { loadSite } from './actions/siteActions';
import LanguageService, { setDateLocale, setMomentLocale } from './shared/LanguageService';
import configureStore from './store/configureStore';
import SystemInfoApi from './api/SystemInfoApi';
import App from './components/App';
import history from './shared/history';
import TelemetryServiceProvider from './telemetry/components/TelemetryServiceProvider';

function Main() {
    const store = configureStore();
    const { isLoading } = useQuery('systemInfo', () => SystemInfoApi.getSystemInfo(), {
        onSuccess: (systemInfo) => store.dispatch(loadSystemInfoSuccess(systemInfo))
    });

    if (isLoading) {
        return null;
    }

    return (
        <ThemeProvider theme={theme}>
            <Provider store={store}>
                <Router history={history}>
                    <TelemetryServiceProvider>
                        <DndProvider backend={HTML5Backend}>
                            <App />
                        </DndProvider>
                    </TelemetryServiceProvider>
                </Router>
            </Provider>
            <NotificationsHost />
        </ThemeProvider>
    );
}

try {
    const queryClient = new QueryClient();

    if (window.appConfig) {
        LanguageService.init()
            .then(() => {
                setMomentLocale();
                setDateLocale();

                const store = configureStore();
                LanguageService.setKeyMarkersPolicy(() =>
                    canEditTranslations(store.getState().user)
                );
                store.dispatch(loadSite());

                let targetElement = document.getElementById('app');

                if (targetElement) {
                    render(
                        <div>
                            <QueryClientProvider client={queryClient}>
                                <Main />
                            </QueryClientProvider>
                        </div>,
                        targetElement
                    );
                }
            })
            .catch((error) => {
                handleWhitePageOfDeathError();
                console.error(error);
            });
    }
} catch (error) {
    handleWhitePageOfDeathError();
    console.error(error);
}

function handleWhitePageOfDeathError() {
    let loadingSpinnerElement = document.getElementsByClassName('lds-container');
    if (document && loadingSpinnerElement.length > 0) {
        // @ts-ignore
        loadingSpinnerElement.item(0).style.display = 'none';
    }

    let errorElement = document.getElementById('client-side-error');
    if (document && errorElement) {
        errorElement.style.display = 'flex';
    }

    let reloadButton = document.getElementById('error-reload-button');
    if (document && reloadButton) {
        reloadButton.addEventListener('click', () => {
            window.location.reload();
        });
    }
}

// @ts-ignore
Date.prototype.ToBrowserDate = function () {
    return { value: this, offset: this.getTimezoneOffset() };
};
